import { productDetails } from './productData';
import { blogPosts } from './blogData';

export const SITE_URL = process.env.REACT_APP_SITE_URL;

const BRAND_IMAGE = 'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/j2wu35i4_sadasf.png';

const staticMetadata = {
  '/': {
    title: 'Etiteks | Labels & Packaging Manufacturer',
    description: 'Woven labels, care labels, hang tags and patches made in Istanbul since 1983. MOQ from 50 pieces, OEKO-TEX, GRS and FSC certified. Quote within 24 hours.',
    image: 'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/iri47kwe_fdsfdsfs%20%282%29.jpg'
  },
  '/capabilities': {
    title: 'Production Capabilities | Etiteks',
    description: 'Explore Etiteks production capabilities, from graphic preparation and weaving to printing, finishing, quality control and shipment from Istanbul.',
    image: BRAND_IMAGE
  },
  '/sustainability': {
    title: 'Sustainability & Certifications | Etiteks',
    description: 'Discover Etiteks sustainable materials, recycled label options, certifications and responsible production practices.',
    image: 'https://images.unsplash.com/photo-1448375240586-882707db888b?w=1600&q=70&fm=webp'
  },
  '/references': {
    title: 'Brands We Serve | Etiteks',
    description: 'Explore the fashion and apparel brands served by Etiteks with labels, hang tags, patches and packaging.',
    image: BRAND_IMAGE
  },
  '/blog': {
    title: 'Label Manufacturing Insights | Etiteks',
    description: 'Guides to garment labels, European textile regulations, sustainable materials and sourcing labels from Türkiye.',
    image: BRAND_IMAGE
  },
  '/about': {
    title: 'About Etiteks | Label Manufacturer Since 1983',
    description: 'Learn about Etiteks, an Istanbul label and packaging manufacturer founded in 1983, serving apparel brands across Europe and beyond.',
    image: BRAND_IMAGE
  },
  '/faq': {
    title: 'Woven Label FAQ: MOQ, Lead Times & Certifications | Etiteks',
    description: 'Answers to 15 questions about Etiteks garment labels, minimum orders, production times, samples, certifications, artwork and shipping.',
    image: BRAND_IMAGE
  },
  '/contact': {
    title: 'Contact Etiteks | Labels & Packaging Quotes',
    description: 'Contact Etiteks in Istanbul for custom labels and packaging, samples and project quotations.',
    image: BRAND_IMAGE
  }
};

export const routeMetadata = {
  ...staticMetadata,
  ...Object.fromEntries(Object.entries(productDetails).map(([slug, product]) => [
    `/products/${slug}`,
    { title: `${product.en.title} | Etiteks`, description: product.en.subtitle, image: product.images?.[0] || BRAND_IMAGE }
  ])),
  '/products/branding-labels': {
    title: 'Custom Woven & Care Labels Manufacturer | Etiteks',
    description: 'Etiteks manufactures custom woven labels, printed care labels and heat transfers in Istanbul. Explore label types, cut and fold options, and request a quote.',
    image: productDetails['branding-labels']?.images?.[0] || BRAND_IMAGE
  },
  ...Object.fromEntries(blogPosts.en.map((post) => [
    `/blog/${post.id}`,
    { title: `${post.title} | Etiteks`, description: post.excerpt, image: post.image, type: 'article' }
  ]))
};

const titleOverrides = {
  '/products/hang-tags': 'Custom Hang Tags Manufacturer | Etiteks',
  '/products/care-composition': 'Woven & Embroidered Patches | Etiteks',
  '/products/packaging': 'Custom Packaging Boxes & Bags | Etiteks',
  '/blog/sustainable-label-supplier-europe': 'Sustainable Label Supplier for Europe | Etiteks',
  '/blog/eu-digital-product-passport-garment-labels': 'EU Digital Product Passport for Garment Labels | Etiteks',
  '/blog/woven-label-manufacturer-europe': 'Woven Label Manufacturer for Europe | Etiteks',
  '/blog/garment-label-manufacturer-turkey': 'Garment Label Manufacturer in Turkey | Etiteks',
  '/blog/sourcing-labels-from-turkey': 'Sourcing Labels from Turkey: 2026 Guide | Etiteks',
  '/blog/eu-textile-labeling-regulations': 'EU Textile Labeling Regulations Guide | Etiteks'
};

Object.entries(titleOverrides).forEach(([path, title]) => {
  if (routeMetadata[path]) routeMetadata[path].title = title;
});

export const prerenderPaths = Object.keys(routeMetadata);

export const absoluteUrl = (pathname) => {
  if (!SITE_URL) throw new Error('REACT_APP_SITE_URL must be configured');
  return new URL(pathname, SITE_URL).href.replace(/\/$/, pathname === '/' ? '/' : '');
};

export const getRouteMetadata = (pathname) => {
  const route = pathname.replace(/\/$/, '') || '/';
  const metadata = routeMetadata[route];
  if (!metadata) {
    return {
      title: 'Page Not Found | Etiteks',
      description: 'The requested Etiteks page could not be found.',
      noindex: true,
      image: BRAND_IMAGE,
      canonical: absoluteUrl('/'),
      type: 'website'
    };
  }
  return {
    ...metadata,
    type: metadata.type || 'website',
    canonical: absoluteUrl(route)
  };
};
